import React from "react";

import {LLSportBettingButtonWrapper} from "../../../../../components";


export const PlayersMarketRowMobile = ({item}) => (
    <div
        className="match-player-market__bets"
        key={item.id + item.replacedSpecifier}
    >
        <div className="match-player-market__bets-content">
            {item.betRowsList.map(row => row.bets.map(bet => bet ?
                <LLSportBettingButtonWrapper
                    bet={bet}
                    key={bet?.id}
                    withShortName={true}
                    className="match-details__bet"
                /> : null
            ))}
        </div>
    </div>
);